export enum FullScreenStateEnum {
    'Inactive',
    'Active',
    'ClosedByKeyboard',
    'ClosedByButtonClick'
}
